<zuper-dialer-overlay></zuper-dialer-overlay>
<router-outlet></router-outlet>
<app-toast [show]="showToast" [message]="message"></app-toast>
<app-full-screen-loader *ngIf="showFullScreenLoader" class="absolute h-full w-full bg-white opacity-75"
    style="z-index: 1000;">
</app-full-screen-loader>
<div [hidden]="true" style="width: 70%;">
    <lightgallery [settings]="settings" [onAfterAppendSubHtml]="lgAppendSubHTML" [onInit]="lightOnInit">
        <a href=""></a>
    </lightgallery>
</div>
<ng-container *ngIf="sdkIframeUrl">
    <iframe #sdkFrame [src]="sdkIframeUrl" width="100%" height="400px" [title]="title" style="position: absolute;
    left: -9999px;" id="sdkFrame"></iframe>
</ng-container>
